import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastProvider } from './components/UI';
import App from './App';

import { BrowserRouter } from 'react-router-dom';

// Ensure 100vh works correctly on mobile devices with bottom bars
(function applyRealVh() {
  const setRealVh = () => {
    document.documentElement.style.setProperty(
      '--real-vh',
      `${window.innerHeight}px`
    );
  };
  setRealVh();
  window.addEventListener('resize', setRealVh);
})();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    {/* Wraps everything: useToast() resolves to this single stack, so a toast
        raised anywhere in the app is actually displayed. */}
    <ToastProvider>
      <App />
    </ToastProvider>
  </BrowserRouter>
);